import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { SentryService } from './sentry.service';

@Injectable({
    providedIn: 'root',
})
export class InitService {
    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private sentry: SentryService
    ) {}
}
